var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('td',{staticClass:"text-right d-none d-md-table-cell"},[_vm._v(" "+_vm._s(_vm.duration)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }